var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.644,
    height: 16,
    viewBox: "0 0 16.644 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-5 22.85) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    transform: "translate(6.85 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M176.49,12.6V7.715a.714.714,0,1,0-1.429,0V12.6a3.628,3.628,0,0,0,0,7.114V22.93a.714.714,0,1,0,1.429,0V19.715a3.628,3.628,0,0,0,0-7.114Zm-.714,5.753a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,175.776,18.355Z",
    transform: "translate(-163.401 -7)",
    fill: "#1a1824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M11.19,7.013v-1.3a.715.715,0,1,0-1.429,0v1.3a3.628,3.628,0,0,0,0,7.114v6.8a.715.715,0,1,0,1.429,0V14.121a3.625,3.625,0,0,0,0-7.108Zm-.715,5.753a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,10.476,12.766Z",
    transform: "translate(-6.85 -5)",
    fill: "#1a1824"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.eb1a5e1486564c1416f93ea48d45367c.svg";
export { ForwardRef as ReactComponent };